// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
h1[data-v-47aa12d3] {
  margin-top: 3em;
  margin-left: 2em;
}
p[data-v-47aa12d3] {
  margin-left: 5em;
}
ul[data-v-47aa12d3] {
  list-style: none;
  margin: 0 5em 1em;
  padding-left: 0;
  flex: 3;
}
li[data-v-47aa12d3] {
  margin: 2px;
  padding: 2px;
  cursor: pointer;
}
#connections[data-v-47aa12d3] {
  max-width: 800px;
  display: flex;
  gap: 1em;
  flex-wrap: wrap;
}
.connection-info[data-v-47aa12d3] {
  font-size: smaller;
  flex: 5;
}
button[data-v-47aa12d3] {
  margin: 0.5em auto;
  width: 10em;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings.vue"],"names":[],"mappings":";AAgDA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,OAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB","sourcesContent":["<script setup lang=\"ts\">\nimport { i18n } from '@/assets/i18n';\nimport { ref } from 'vue';\nimport { ENV } from '../../env';\nimport { Connection, store } from '../store';\nconst PACKAGE = require('../../package.json');\nconst version = PACKAGE.version;\nconst emit = defineEmits(['onClose']);\n\nconst settings: Connection[] = ENV;\nlet selected = ref<{ [key: string]: string }>(store.connection);\n\nfunction close(): void {\n  emit('onClose');\n}\n\nfunction select(c: Connection): void {\n  selected.value = c;\n  c && store.setConnection(c);\n}\n\nfunction isSelected(c: Connection): boolean {\n  return c.NAME === selected.value?.NAME;\n}\n\nfunction getField(key: string) {\n  return selected.value[key];\n}\n</script>\n\n<template>\n  <h1>{{ i18n('SETTINGS') }}</h1>\n  <p>{{ i18n('VERSION_LABEL') }} {{ version }}</p>\n  <div id=\"connections\">\n    <ul>\n      <li v-for=\"connection of settings\" @click=\"select(connection)\">\n        <input type=\"radio\" :checked=\"isSelected(connection)\" /> {{ connection.NAME }}\n      </li>\n    </ul>\n    <ul class=\"connection-info\">\n      <li v-for=\"key of Object.keys(selected)\">{{ key }}: {{ getField(key) }}</li>\n    </ul>\n  </div>\n\n  <button @click=\"close\">{{ i18n('CLOSE') }}</button>\n</template>\n\n<style scoped>\nh1 {\n  margin-top: 3em;\n  margin-left: 2em;\n}\np {\n  margin-left: 5em;\n}\nul {\n  list-style: none;\n  margin: 0 5em 1em;\n  padding-left: 0;\n  flex: 3;\n}\nli {\n  margin: 2px;\n  padding: 2px;\n  cursor: pointer;\n}\n#connections {\n  max-width: 800px;\n  display: flex;\n  gap: 1em;\n  flex-wrap: wrap;\n}\n.connection-info {\n  font-size: smaller;\n  flex: 5;\n}\nbutton {\n  margin: 0.5em auto;\n  width: 10em;\n  display: block;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
